import { render, staticRenderFns } from "./SecretCodeStep.vue?vue&type=template&id=12c748e0&"
import script from "./SecretCodeStep.vue?vue&type=script&lang=ts&"
export * from "./SecretCodeStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports